import React, { Component } from 'react'

import Modal from '../Modal/Modal'
import Form from '../Form/Form'

class EditSeedpage extends Component {

    state = {
        seedpage: this.props.seedpage,
    }

    onSave = () => {
        this.props.onSave(this.state)
    }

    render() {
        const { seedpage = '' } = this.state

        return (
            <Modal
                narrow
                extraClassName="EditSeedpage"
                onCancel={this.props.onClose}
                onSave={this.onSave}
                saveText="Save"
                mode="edit"
                title="Seedpage">
                <Form>
                    <div>
                        <input
                            type="url"
                            autoComplete="off"
                            autoCorrect="off"
                            autoCapitalize="off"
                            spellCheck="false"
                            placeholder="Seed URL"
                            value={seedpage}
                            onChange={e => this.setState({ seedpage: e.target.value })} />
                    </div>
                </Form>
            </Modal>
        )
    }
}

export default EditSeedpage



// WEBPACK FOOTER //
// ./src/components/LBUs/EditSeedpage.js